
const resources = {
    fedexPickupLabel: 'Lieu de ramassage FedEx',
    editLabel: 'Modifier',
    useThisAddress: 'Utiliser cette adresse'
};

export default function getResource(label) {
    return resources[label];
}
